import { SchoolContextType } from '@/App/type'
import { useCurrentSchoolId } from '@/hooks'
import { schoolIdStorage, store } from '@/store'
import { userAgent } from '@seiue/ua'
import { Card, Tabs } from '@seiue/ui'
import { User } from 'packages/sdks-next/growp'
import { AnyValueObj } from 'packages/types'
import { FC, useEffect, useState } from 'react'
import styled from 'styled-components'

import { CodeLogin } from './CodeLogin'
import { PwdLogin } from './PwdLogin'
import { RetrievePassword } from './RetrievePassword'
import { SecondCheck } from './SecondCheck'
import { SelectedUser } from './SelectUser'

/**
 * 登录界面
 *
 * @param param - 参数
 * @param param.schoolConfig - 学校配置
 * @param param.isPreview - 是否是预览
 *
 * @returns main login content
 */
export const MainContent: FC<{
  schoolConfig: SchoolContextType
  isPreview?: boolean
}> = ({ schoolConfig, isPreview }) => {
  const pathname = location.pathname
  const splitArr = pathname.split('login/')
  const curSchoolId = useCurrentSchoolId()
  const [activeKey, setActiveKey] = useState<string>('pwd')
  const [changePassword, setChangePassword] = useState<boolean>(false)
  const [isSecondCheck, setIsSecondCheck] = useState<boolean>(false)
  const [user, setUser] = useState<User>()
  const [loginParam, setLoginParam] = useState<AnyValueObj>()

  const previewSchoolId = splitArr[splitArr.length - 1]

  const schoolId = isPreview ? previewSchoolId : curSchoolId

  useEffect(() => {
    if (schoolId && !isPreview) {
      store.set(schoolIdStorage, Number(schoolId))
    }
  }, [schoolId])

  return (
    <Wrapper>
      <Card
        style={
          userAgent.isMobile
            ? { width: '100%', minWidth: 400, transform: 'scale(2)' }
            : {
                width: '100%',
                minWidth: 400,
                maxWidth: 400,
                height: 480,
                borderRadius: '12px',
              }
        }
        contentStyle={{
          padding: '32px',
        }}
      >
        {changePassword ? (
          <RetrievePassword
            cancelChangePassword={() => setChangePassword(false)}
          />
        ) : isSecondCheck ? (
          <SecondCheck
            schoolConfig={schoolConfig}
            setIsSecondCheck={() => setIsSecondCheck(false)}
            user={user}
          />
        ) : (
          <>
            <img
              height={32}
              src={schoolConfig?.logo || '/logo.svg'}
            />
            <FormWrapper>
              {user?.reflections && user.reflections.length > 1 ? (
                <SelectedUser
                  user={user}
                  loginParam={loginParam}
                />
              ) : (
                <Tabs
                  activeKey={activeKey}
                  onChange={(key) => setActiveKey(key)}
                  items={[
                    {
                      label: '密码登录',
                      key: 'pwd',
                      children: (
                        <PwdLogin
                          isPreview={isPreview}
                          activeKey={activeKey}
                          changePassword={() => setChangePassword(true)}
                          setIsSecondCheck={() => setIsSecondCheck(true)}
                          setUser={setUser}
                        />
                      ),
                    },
                    {
                      label: '验证码登录',
                      key: 'code',
                      children: (
                        <CodeLogin
                          isPreview={isPreview}
                          activeKey={activeKey}
                          setUser={(v: User) => setUser(v)}
                          setLoginParam={(v: AnyValueObj) => setLoginParam(v)}
                        />
                      ),
                    },
                  ]}
                />
              )}
            </FormWrapper>
          </>
        )}
        {/* 暂时隐藏 */}
        {/* <Policy>
            <Radio
              checked={isAgreePolicy}
              onClick={() => {
                setIsAgreePolicy(!isAgreePolicy)
              }}
            >
              <span>{'我已阅读并同意'}</span>
              <StyledLink
                href="/serviceAgreement"
                target="_blank"
              >
                {'服务协议'}
              </StyledLink>
              <span>和</span>
              <StyledLink
                href="/policy"
                target="_blank"
              >
                {'隐私政策'}
              </StyledLink>
            </Radio>
          </Policy> */}
      </Card>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  background: ${(props) => props.theme.background._3};
  text-align: center;
  align-items: center;
  &&& {
    /* .ant-input-affix-wrapper-focused {

    } */
    .ant-formily-item-error-help {
      text-align: left;
      font-size: 12px;
    }
    .ant-input-affix-wrapper {
      border-radius: 8px;
      border-color: transparent;
      background-color: ${(props) => props.theme.background._3};
      &:hover {
        border-color: transparent;
        background-color: ${(props) => props.theme.background._2};
      }
      &:focus-within {
        border-color: ${(props) => props.theme.brand._1};
        background-color: transparent;
      }
      .ant-input {
        background-color: transparent;
        ::placeholder {
          font-size: 14px;
        }
      }
    }
    .ant-tabs-tab {
      .ant-tabs-tab-btn {
        color: ${(props) => props.theme.text._2};
        font-size: 14px;
        font-weight: 400;
      }
    }
    .ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: ${(props) => props.theme.brand._1};
        font-weight: 500;
      }
    }
    .ant-tabs-ink-bar {
      background-color: ${(props) => props.theme.brand._1};
    }
  }
`

const FormWrapper = styled.div`
  padding-top: 40px;
`

/*
const Policy = styled.div`
  position: absolute;
  margin-top: 18px;
`

const StyledLink = styled.a`
  margin: 0 8px;
  color: ${(props) => props.theme.brand._1};
`
*/
